import { render, staticRenderFns } from "./MenahalBroadcasts.vue?vue&type=template&id=2fa523b6&"
import script from "./MenahalBroadcasts.vue?vue&type=script&lang=js&"
export * from "./MenahalBroadcasts.vue?vue&type=script&lang=js&"
import style0 from "./MenahalBroadcasts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports